export default [    //录音
  {
    path: "/recordingList",
    name: 'recordingList',
    component: () => import("@/views/recording/recordingList.vue")
  }
]
